import React from 'react'
import { ArrowDown2, ArrowUp2 } from 'iconsax-react'

import { useNewConversationCount } from '../../../../providers/NewConversationCountProvider'
import useStyles from './styles'

const Update = ({ selectHandler }) => {
  const { count, getNextID } = useNewConversationCount()

  const classes = useStyles()

  const next = getNextID()

  const handleScroll = () => {
    const { id, onClick } = next
    if (id && onClick) {
      selectHandler(id)
      onClick()
    }
  }

  let Icon = null
  if (next?.above) {
    Icon = ArrowUp2
  }
  if (next?.below) {
    Icon = ArrowDown2
  }

  if (count === 0 || !next) {
    return null
  }

  return (
    <div onClick={handleScroll} className={classes.root}>
      <div>+ {count} NEW</div>

      {Icon && <Icon className={classes.icon} />}
    </div>
  )
}

export default Update
